import { Grid } from '@mui/material';
import { FC, MouseEventHandler } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';

import { APP_URLS } from 'src/constants';
import { useAuth } from 'src/contexts';
import { Typography } from 'src/components';

interface MainLayoutProps {
  isAdmin: boolean;
}

const MainLayout: FC<MainLayoutProps> = ({ isAdmin }) => {
  const { onSignOut } = useAuth();
  const navigate = useNavigate();

  const handleClickLogOut: MouseEventHandler = async (event) => {
    event.preventDefault();
    await onSignOut();
    navigate(APP_URLS.LOGIN);
  };

  return (
    <>
      <nav
        aria-label="Horizontal School Form Navigation"
        className="cb-menu-list cb-menu-list-horizontal position-sticky cb-border-bottom cb-box-shadow-bottom cb-white-bg display-flex justify-content-xs-between align-items-xs-center"
        style={{ height: 56, paddingLeft: 16, top: 0, zIndex: 100 }}>
        <Typography variant="h3" style={{ fontWeight: 'bold' }}>
          School Code Request Form
        </Typography>
        <ul>
          <li>
            <Link className="cb-menu-link" to={APP_URLS.HOME}>
              Home
            </Link>
          </li>
          {!isAdmin && (
            <li>
              <Link className="cb-menu-link" to={APP_URLS.SEARCH}>
                Search
              </Link>
            </li>
          )}
          <li>
            <Link className="cb-menu-link" to={APP_URLS.HELP} >
              Help
            </Link>
          </li>
          <li>
            <Link className="cb-menu-link" to={APP_URLS.LOGIN} onClick={handleClickLogOut}>
              Log Out
            </Link>
          </li>
        </ul>
      </nav>
      <Grid container justifyContent="center" sx={{ p: 3 }}>
        {isAdmin ? (
          <Grid item xl={12} lg={12} xs={12}>
            <Outlet />
          </Grid>
        ) : (
          <Grid item xl={10} lg={12} xs={12}>
            <Outlet />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default MainLayout;
